import { lazy, Suspense } from "react";
import { GameTopbar } from "./components/GameTopbar.jsx";
import { useRoom } from "./contexts/RoomContext.jsx";
import { SoundButton } from "./contexts/SoundContext.jsx";
import { HomePage } from "./pages/HomePage.jsx";
import { FinalRankingPage } from "./pages/FinalRankingPage.jsx";
import { LobbyPage } from "./pages/LobbyPage.jsx";
import { PuzzleImageSelectionPage } from "./pages/PuzzleImageSelectionPage.jsx";
import { PuzzleMultiplayerPage } from "./pages/PuzzleMultiplayerPage.jsx";
import { StopMultiplayerPage } from "./pages/StopMultiplayerPage.jsx";
import { StopRoundResultPage } from "./pages/StopRoundResultPage.jsx";
import { StopVotingPage } from "./pages/StopVotingPage.jsx";
import { TermMultiplayerPage } from "./pages/TermMultiplayerPage.jsx";
import {
  INSTITUTIONAL_PATHS,
  InstitutionalPage,
} from "./pages/InstitutionalPage.jsx";

const WhoAmICharacterSelectionPage = lazy(() =>
  import("./pages/WhoAmICharacterSelectionPage.jsx").then((module) => ({
    default: module.WhoAmICharacterSelectionPage,
  })),
);
const WhoAmIRoundReadyPage = lazy(() =>
  import("./pages/WhoAmIRoundReadyPage.jsx").then((module) => ({
    default: module.WhoAmIRoundReadyPage,
  })),
);
const WhoAmIActiveRoundPage = lazy(() =>
  import("./pages/WhoAmIActiveRoundPage.jsx").then((module) => ({
    default: module.WhoAmIActiveRoundPage,
  })),
);
const WhoAmIRoundResultPage = lazy(() =>
  import("./pages/WhoAmIRoundResultPage.jsx").then((module) => ({
    default: module.WhoAmIRoundResultPage,
  })),
);

function Loading() {
  return (
    <div className="game-loading" role="status" aria-live="polite">
      <span aria-hidden="true" />
      <strong>Preparando a diversão…</strong>
    </div>
  );
}

export default function App() {
  const room = useRoom();
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const institutional = INSTITUTIONAL_PATHS.includes(path);
  let content;
  if (institutional) content = <InstitutionalPage path={path} />;
  else if (!room.roomCode) content = <HomePage />;
  else if (!room.roomData)
    content = (
      <div className="container-sm text-center" style={{ marginTop: 100 }}>
        <h2 className="title">Conectando à sala...</h2>
      </div>
    );
  else {
    const topbar = (
      <GameTopbar
        isHost={room.isHost}
        endGame={room.endGame}
        leaveRoom={room.leaveRoom}
        trocarJogoDuranteJogo={room.trocarJogoDuranteJogo}
      />
    );
    const screens = {
      lobby: <LobbyPage />,
      jogando_termo: (
        <>
          {topbar}
          <TermMultiplayerPage />
        </>
      ),
      jogando_quebra_cabeca: (
        <>
          {topbar}
          <PuzzleMultiplayerPage />
        </>
      ),
      escolhendo_imagem_quebra_cabeca: (
        <>
          {topbar}
          <PuzzleImageSelectionPage />
        </>
      ),
      jogando_stop: (
        <>
          {topbar}
          <StopMultiplayerPage />
        </>
      ),
      votacao_stop: (
        <>
          {topbar}
          <StopVotingPage />
        </>
      ),
      fim_rodada_stop: (
        <>
          {topbar}
          <StopRoundResultPage />
        </>
      ),
      ranking_final: <FinalRankingPage />,
      escolhendo_personagem: (
        <>
          {topbar}
          <WhoAmICharacterSelectionPage />
        </>
      ),
      sorteando_jogador: (
        <>
          {topbar}
          <WhoAmIRoundReadyPage />
        </>
      ),
      rodada_ativa: (
        <>
          {topbar}
          <WhoAmIActiveRoundPage />
        </>
      ),
      fim_rodada: (
        <>
          {topbar}
          <WhoAmIRoundResultPage />
        </>
      ),
    };
    content = screens[room.roomData.status] || <Loading />;
  }
  return (
    <>
      {!institutional && <SoundButton />}
      <Suspense fallback={<Loading />}>{content}</Suspense>
    </>
  );
}
